import { Controller } from "@hotwired/stimulus"

// Move a press clip to another DPK (PRT_Clip_Move_And_Copy_Plan.md, D4,
// W1, W3). ONE modal per Press Clips page, opened from any card's More
// menu with that clip's move url and its W1 confirm body as action params.
// The form inside is the Address Book shape: the shared client control
// (eligible DPKs only) and app-confirm-form, whose confirm names both
// artists (it fills %{client} with the picked name) and focuses Cancel.
// "Move clip" stays disabled until a client is picked.
export default class extends Controller {
  static targets = ["modal", "form", "submit"]

  connect() {
    this.onKeydown = (event) => {
      if (event.key !== "Escape" || this.modalTarget.classList.contains("hidden")) return
      // The confirm sits above this modal and handles its own Escape.
      if (document.querySelector("#turbo-confirm-dialog:not(.hidden), .app-modal-backdrop")) return
      this.close()
    }
    document.addEventListener("keydown", this.onKeydown)
  }

  disconnect() {
    document.removeEventListener("keydown", this.onKeydown)
  }

  open(event) {
    event.preventDefault()
    this.opener = event.currentTarget
    this.formTarget.action = event.params.url
    this.formTarget.dataset.appConfirmFormMessageValue = event.params.message
    const picker = this.picker()
    const control = picker && this.application.getControllerForElementAndIdentifier(picker, "client-picker")
    if (control) {
      control.unset()
      control.inputTarget.value = ""
      control.close()
    }
    this.submitTarget.disabled = true
    this.modalTarget.classList.remove("hidden")
    document.body.style.overflow = "hidden"
    picker?.querySelector("input[type='text']")?.focus()
  }

  picked(event) {
    this.submitTarget.disabled = !event.detail.id
  }

  close() {
    this.modalTarget.classList.add("hidden")
    document.body.style.overflow = ""
    this.opener?.closest("details")?.querySelector("summary")?.focus()
  }

  picker() {
    return this.formTarget.querySelector("[data-controller~='client-picker']")
  }
}
